function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.03 3.5l.524.033c3.104.187 5.785 2.207 6.832 5.115l.096.288.016.087.002.047v7.035c0 .68-.456 1.268-1.1 1.446l-.141.032-13 2.275c-.816.142-1.594-.403-1.737-1.22l-.016-.128-.006-.13v-6.693c-.008-.107.02-.218.092-.316l.062-.07 8-7.662c.08-.077.184-.125.293-.136l.083-.002zm6.47 10.942l-14 2.545v1.415l.007.064c.043.242.252.413.49.414l.09-.007 13-2.275c.209-.037.368-.2.405-.404l.008-.089v-1.663zm0-1.765l-14 2.545v.749l13.97-2.54.03-.003v-.751zm0-3.012l-14 2.45v2.091l13.97-2.54.03-.003V9.665zm-6.313-5.153l-6.659 6.377 12.795-2.213-.078-.183c-.952-2.11-2.929-3.594-5.234-3.911l-.257-.03-.26-.021-.307-.019zM14 5c.828 0 1.5.672 1.5 1.5S14.828 8 14 8s-1.5-.672-1.5-1.5S13.172 5 14 5z"
});

var SvgIconDessert = function SvgIconDessert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDessert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-dessert.53434b0d.svg";
export { ForwardRef as ReactComponent };